import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';

import { LeftSideMenuComponent } from './left-side-menu.component';
import { RouterModule } from '@angular/router';
import { ChannelsListComponent } from './channels-list/channels-list.component';
import { TrialExpireComponent } from './trial-expire/trial-expire.component';
import { UserDetailsComponent } from './user-details/user-details.component';

@NgModule({
    declarations: [LeftSideMenuComponent, ChannelsListComponent, TrialExpireComponent, UserDetailsComponent],
    imports: [CommonModule, SharedModule, RouterModule],
    exports: [LeftSideMenuComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LeftSideMenuModule {}
